import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useParams } from 'react-router-dom';
import MainLayout from '../../layouts/MainLayout';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGift, faMapMarkerAlt, faCity, faStar, faGlobe, faBook, faBookOpen, faDownload, faGifts, faHandsHelping, faPhone, faRainbow, faShoppingCart, faStore, faVideo, faQrcode } from '@fortawesome/free-solid-svg-icons';
import './ChaiWai.css';
import chaiwaiimage from '../../assets/pageimages/ChaiWai.webp';

function ChaiWaiHome() {

  return (
    <MainLayout>
      <div>
        <h2 className='text-lg mt-1 mx-8 border-b border-b-gray-300 text-white'>Think5Whys ChaiWai</h2>
      </div>
      <div className="main-content">
        <div className="top-section top-section mt-4 ml-2 mr-0 border border-b-gray-300">
            <div className="button-links flex align-middle justify-center bg-gray-500">
            <div className="bottom-buttons-box"><Link to="/chaiwai-generatecode" className="top-button-link"><FontAwesomeIcon icon={faQrcode} className="chaiwai-bottomlink-style" />My Code</Link></div>
            <div className="bottom-buttons-box"><Link to="/chaiwai-scan" className="top-button-link"><FontAwesomeIcon icon={faQrcode} className="chaiwai-bottomlink-style" />Eat, Sip & Scan</Link></div>
            <div className="bottom-buttons-box"><Link to="/chaiwai-myrewards" className="top-button-link"><FontAwesomeIcon icon={faQrcode} className="chaiwai-bottomlink-style" />My Rewards</Link></div>
            <div className="bottom-buttons-box"><Link to="/chaiwai-mycustomers" className="top-button-link"><FontAwesomeIcon icon={faStar} className="chaiwai-bottomlink-style" />My Customers</Link></div>
          </div>
        </div>
        <div className="image-container">
          <div className="relative inset-0 flex border border-b-gray-300">
            <img id="chaiwai-id" src={chaiwaiimage} alt="ChaiWai Image" />
          </div>
        </div>
      </div>
    </MainLayout>
  );
}

export default ChaiWaiHome;
